import MDBox from "components/MDBox";
import Dialog from "@mui/material/Dialog";
import MDTypography from "components/MDTypography";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";

import Lottie from 'react-lottie-player'

import anm1 from '../../assets/animations/FXBHMwjR1l.json';
import DialogTitle from "@mui/material/DialogTitle";
import { useState } from "react";
import MDBackdrop from "components/MDBackdrop";
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import { useMaterialUIController } from "context";
import theme from "assets/theme";

function Completion(props) {

    const [isBackdrop] = useState(false);
    const [controller] = useMaterialUIController();
    const { darkMode } = controller;
    const { onClose } = props;


    const handleClose = () => {
        onClose(false);
        window.location.reload();
    };


    return (
        <>
            <MDBackdrop isBackdrop={isBackdrop} />
            <Dialog open={props.isDialog} onClose={handleClose}
                
                
                maxWidth="sm"
            >
                <DialogTitle style={darkMode ? {
                    backgroundColor: "#202940", color: "#ffffff", display: "flex", alignItems: "center",
                    
                    justifyContent: "flex-end"
                } : {
                    theme, display: "flex", alignItems: "center",
                    
                    justifyContent: "flex-end"
                }}>

           
                    <IconButton aria-label="delete" style={darkMode ? { color: "#ffffff" } : theme} onClick={handleClose}>
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent style={darkMode ? { backgroundColor: "#202940", color: "#ffffff", 
                    paddingBottom: "0px" 
                    } : {theme, paddingBottom: "0px"}}>
                    <MDBox pt={0} pb={0} style={{ display: "flex", justifyContent: "center", 
                        
                        }}>
                  
                        <Lottie
                            loop
                            animationData={anm1}
                            play
                            style={{ width: 250, height: 250 }}
                        />
                 
                    </MDBox>
                </DialogContent>
                <DialogActions style={darkMode ? { backgroundColor: "#202940", justifyContent: "space-evenly", color: "#ffffff" } : { theme, justifyContent: "space-evenly" }}>
             
                    <MDTypography
                        variant="button"
                        fontWeight="bold"
                        color="secondary"
                        textTransform="capitalize"
                    >
                        User Created successfully!!
                    </MDTypography>
                </DialogActions>
            </Dialog>
        </>
    );
}

export default Completion;